import { render, staticRenderFns } from "./ModalOPME.vue?vue&type=template&id=2bb4b362&scoped=true"
import script from "./ModalOPME.vue?vue&type=script&lang=ts"
export * from "./ModalOPME.vue?vue&type=script&lang=ts"
import style0 from "./ModalOPME.vue?vue&type=style&index=0&id=2bb4b362&prod&lang=scss&scoped=true"
import style1 from "./ModalOPME.vue?vue&type=style&index=1&id=2bb4b362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb4b362",
  null
  
)

export default component.exports